<template>
    <div class="wrapper">
        <img src="../assets/images/logo-air.png" alt=""/>
        <div class="inner text-center">
            <h1 class="text-danger">404</h1>
            <h3>Тут нічого немає...</h3>
            <button @click="$router.replace('/')" class="btn btn-lg font-weight-bold btn-outline-success">На головну</button>
        </div>
    </div>
</template>

<script>

    import EventBus from "../components/EventBus";

    export default {
        name: "NotFound",
        mounted() {
            document.title = "Розумне місто - 404";
            EventBus.$emit("PRELOADER_HIDE")
        }
    }

</script>

<style lang="less" scoped>

    .wrapper {
        width: 100vw;
        height: 100vh;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;

        & > img {
            width: 200px;
            max-width: 30%;
            position: absolute;
            top: 1rem;
            left: 1rem;
        }

        .inner {
            h1{
                font-weight: 900;
                font-size: 8rem;
            }

            h3{
                font-weight: 300;
                font-size: 4rem;
                padding-bottom: 2rem;
            }

            button{
                border-radius: 2rem;
                font-size: 2rem;
            }
        }
    }

</style>
